import { render, staticRenderFns } from "./DocumentAi.vue?vue&type=template&id=4eeeb8c4&scoped=true&"
import script from "./DocumentAi.vue?vue&type=script&lang=js&"
export * from "./DocumentAi.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAi.vue?vue&type=style&index=0&id=4eeeb8c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeeb8c4",
  null
  
)

export default component.exports